module.exports = __webpack_public_path__ + "static/media/coin.8975ba96.svg";